/**
 * ★ Fase 94 (Doc 02) — Scroll alla sezione indicata nell'hash dell'URL (es. /f/it#verification)
 * al mount della landing (le pagine sono client-rendered: il browser da solo non trova l'ancora).
 * Riprova per ~2s finché l'elemento compare (contenuti caricati via API).
 */
import { useEffect } from 'react';

export function useHashScroll({ delayMs = 150, retries = 12 } = {}) {
  useEffect(() => {
    const raw = typeof window !== 'undefined' ? window.location.hash : '';
    const id = raw ? decodeURIComponent(raw.replace(/^#/, '')) : '';
    if (!id) return undefined;
    let attempts = 0;
    let timer = null;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (attempts++ < retries) timer = setTimeout(tryScroll, delayMs);
    };
    timer = setTimeout(tryScroll, delayMs);
    return () => { if (timer) clearTimeout(timer); };
  }, [delayMs, retries]);
}
